import { usePersistedSetting } from '@core/store/persistedSettings/hooks'

export const useCookiesSeen = () => {
  return usePersistedSetting('cookiesSeen')
}
